import { makeStyles } from '@mui/styles'

export default makeStyles((theme) => ({
    root: {
        marginLeft: 10,
        marginRight: 10,
        marginBottom: 10,
    },
}))
